import { render, staticRenderFns } from "./SeatClaim.vue?vue&type=template&id=120a1987&scoped=true"
import script from "./SeatClaim.vue?vue&type=script&lang=js"
export * from "./SeatClaim.vue?vue&type=script&lang=js"
import style0 from "./SeatClaim.vue?vue&type=style&index=0&id=120a1987&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a1987",
  null
  
)

export default component.exports